import { m } from '@pricedrop/i18n';
import { Link } from '@tanstack/react-router';
import SearchIcon from 'lucide-react/dist/esm/icons/search';
import ShoppingCart from 'lucide-react/dist/esm/icons/shopping-cart';
import { Button } from '@/components/ui/button';

export default function ItemNotFound() {
  return (
    <div className="my-16 flex w-full flex-col items-center space-y-6 px-4 sm:my-24">
      <div className="flex items-center justify-center text-7xl sm:text-8xl">
        <ShoppingCart className="h-20 w-20 text-muted-foreground/40 sm:h-28 sm:w-28" />
      </div>

      <h1 className="text-center text-2xl font-bold sm:text-3xl md:text-4xl">
        {m.itemNotFound_title()}
      </h1>

      <p className="max-w-md text-center text-muted-foreground">{m.itemNotFound_description()}</p>

      <p className="max-w-sm text-center text-sm text-muted-foreground">
        {m.itemNotFound_searchInvite()}
      </p>

      <div className="flex flex-col gap-3 sm:flex-row">
        <Button asChild>
          <Link to="/items">
            <SearchIcon className="me-2 h-4 w-4" />
            {m.itemNotFound_searchButton()}
          </Link>
        </Button>
        <Button variant="outline" asChild>
          <Link to="/">{m.common_backToHome()}</Link>
        </Button>
      </div>
    </div>
  );
}
